export default __webpack_public_path__ + "static/media/Staying.e9c87fc3.svg";